import { motion } from "polyfill/motion-polyfill/motion-polyfill";
import styles from "./my-page-loader.module.less";

const MyPageLoader = (props) => {
  const loadingContainerVariants = {
    start: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const circleAnimationVariants = {
    initial: {
      y: "0%",
    },
    start: {
      y: ["0%", "-75%", "0%"],
      transition: {
        duration: 0.6,
        ease: "easeInOut",
        times: [0, 0.5, 1],
        loop: Infinity,
        repeatDelay: 0.75,
      },
    },
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, ease: "easeIn" }}>
      <motion.div
        className={["dot-container", styles.circleContainer].join(" ")}
        variants={loadingContainerVariants}
        initial="initial"
        animate="start"
      >
        <motion.span className={["dot", styles.dot].join(" ")} variants={circleAnimationVariants} />
        <motion.span className={["dot", styles.dot].join(" ")} variants={circleAnimationVariants} />
        <motion.span className={["dot", styles.dot].join(" ")} variants={circleAnimationVariants} />
      </motion.div>
    </motion.div>
  );
};

export default MyPageLoader;
